import React, { useState } from 'react';
import ReviewCard from '../components/ReviewCard';
import SavedKahanisPage from './SavedKahanisPage';
import Loader from '../components/Loader';
function SidebarLink({ icon, label, isActive, onClick }) {
  const [hovered, setHovered] = useState(false);
  return (
    <div
      onClick={onClick}
      onMouseEnter={() => setHovered(true)}
      onMouseLeave={() => setHovered(false)}
      style={{
        display: 'flex', alignItems: 'center', gap: 10, position: 'relative',
        padding: '12px 10px',
        color: isActive ? 'var(--blue)' : hovered ? 'var(--blue)' : 'var(--text)',
        fontWeight: isActive ? 700 : 600, fontSize: 13,
        transition: 'all 0.15s cubic-bezier(0.4, 0, 0.2, 1)',
        cursor: 'pointer', fontFamily: 'var(--sans)',
        borderRadius: 8,
        background: isActive ? 'var(--surface)' : 'transparent',
        boxShadow: isActive ? '0 1px 3px rgba(0,0,0,0.06)' : 'none',
        margin: '2px 0',
      }}
    >
      <span style={{ fontSize: 16 }}>{icon}</span>
      <span>{label}</span>
      {isActive && (
        <div style={{
          position: 'absolute', right: 10,
          width: 6, height: 6, borderRadius: '50%', background: 'var(--blue)',
        }} />
      )}
    </div>
  );
}

function MyKahaniSidebar({ subView, setSubView }) {
  return (
    <aside style={{
      width: 200, flexShrink: 0,
      position: 'sticky', top: 68, height: 'min-content',
      display: 'flex', flexDirection: 'column', gap: 12,
    }}>
      {/* Nav links */}
      <div style={{
        background: 'var(--surface2)', border: '1px solid var(--border)',
        borderRadius: 14, padding: '6px 10px',
      }}>
        <SidebarLink
          icon="🔖" label="Saved"
          isActive={subView === 'saved'}
          onClick={() => setSubView(subView === 'saved' ? 'my-kahanis' : 'saved')}
        />
      </div>

    </aside>
  );
}

export default function MyKahaniPage({
  user, reviews, loading,
  onAddClick, onEditClick, onDeleteClick,
  onSeeSimilar, onLogout, setView, onHomeClick,
}) {
  const [subView, setSubView] = useState('my-kahanis');

  const isGuest = user?.isAnonymous || user?.provider === 'anon';

  return (
    <>
    <div className="my-kahani-layout" style={{
      maxWidth: 1100, margin: '0 auto',
      padding: '24px 32px 80px',
      display: 'flex', gap: 20, alignItems: 'flex-start',
    }}>
      {!isGuest && (
        <div className="my-kahani-sidebar-col">
          <MyKahaniSidebar
            subView={subView} setSubView={setSubView}
          />
        </div>
      )}

      <main className="my-kahani-main" style={{ flex: 1, minWidth: 0 }}>
        {subView === 'my-kahanis' ? (
          <div style={{ animation: 'fadeUp 0.35s ease-out' }}>
            {/* Header */}
            <div className="my-kahani-header-row" style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', marginBottom: 20 }}>
              <div className="my-kahani-title-block">
                <h1 style={{ fontFamily: 'var(--display)', fontSize: 22, fontWeight: 900, margin: '0 0 4px', color: 'var(--text)' }}>
                  My Kahani
                </h1>
                <p style={{ fontSize: 13, color: 'var(--text3)', margin: 0 }}>
                  Your contributed interview experiences
                </p>
              </div>
              {!isGuest && (
                <div style={{ display: 'flex', flexDirection: 'row', gap: 10, alignItems: 'center' }}>
                  {/* Desktop: See Similar Kahanis + Share My HireKahani side by side */}
                  {reviews.length > 0 && (
                    <button
                      className="mobile-hide"
                      onClick={() => onSeeSimilar(reviews[0] || null)}
                      style={{
                        background: 'var(--surface)', color: 'var(--blue)', fontFamily: 'var(--sans)',
                        fontSize: 14, fontWeight: 700, padding: '12px 20px', borderRadius: 10,
                        border: '1px solid var(--blue)', cursor: 'pointer', transition: 'all 0.15s', flexShrink: 0,
                      }}
                    >
                      See Similar Kahanis
                    </button>
                  )}
                  <button
                    className="mobile-hide"
                    onClick={onAddClick}
                    style={{
                      background: 'var(--blue)', color: '#fff', fontFamily: 'var(--sans)',
                      fontSize: 14, fontWeight: 700, padding: '12px 20px', borderRadius: 10,
                      border: 'none', cursor: 'pointer', transition: 'all 0.15s',
                      flexShrink: 0, boxShadow: '0 4px 10px rgba(14,165,233,0.2)',
                    }}
                    onMouseEnter={e => { e.currentTarget.style.background = '#0284c7'; e.currentTarget.style.transform = 'translateY(-1px)'; }}
                    onMouseLeave={e => { e.currentTarget.style.background = 'var(--blue)'; e.currentTarget.style.transform = 'translateY(0)'; }}
                  >
                    + Share My HireKahani
                  </button>
                  {/* Mobile: Share only */}
                  <button
                    className="mobile-show"
                    onClick={onAddClick}
                    style={{
                      background: 'var(--blue)', color: '#fff', fontFamily: 'var(--sans)',
                      fontSize: 15, fontWeight: 700, padding: '13px 0', borderRadius: 10,
                      border: 'none', cursor: 'pointer', transition: 'all 0.15s',
                      flexShrink: 0, width: '100%', boxShadow: '0 4px 10px rgba(14,165,233,0.2)',
                    }}
                  >
                    + Share My HireKahani
                  </button>
                </div>
              )}
            </div>


            {/* Mobile: See Similar Kahanis button below Share button */}
            {!isGuest && reviews.length > 0 && (
              <button
                className="mobile-show"
                onClick={() => onSeeSimilar(reviews[0] || null)}
                style={{
                  width: '100%', background: 'transparent', color: 'var(--blue)',
                  fontFamily: 'var(--sans)', fontSize: 15, fontWeight: 700,
                  padding: '13px 0', borderRadius: 10, marginTop: 10, marginBottom: 16,
                  border: '1px solid var(--blue)', cursor: 'pointer',
                  justifyContent: 'center', alignItems: 'center',
                }}
              >
                See Similar Kahanis
              </button>
            )}

            {/* Reviews */}
            {loading ? (
              <Loader inline message="Loading your kahanis..." />
            ) : reviews.length === 0 ? (
              <div style={{ textAlign: 'center', padding: '60px 0', color: 'var(--text3)', fontSize: 14 }}>
                <div style={{ fontSize: 48, marginBottom: 16 }}>📝</div>
                <div style={{ fontWeight: 600, marginBottom: 8 }}>No kahanis yet</div>
                <div style={{ fontSize: 13, marginBottom: 20 }}>Share your interview experience to get started!</div>
                <button
                  onClick={onAddClick}
                  style={{
                    background: 'var(--blue)', color: '#fff', fontFamily: 'var(--sans)',
                    fontSize: 13, fontWeight: 700, padding: '10px 24px', borderRadius: 8,
                    border: 'none', cursor: 'pointer',
                  }}
                >
                  + Share My HireKahani
                </button>
              </div>
            ) : (
              reviews.map((r, i) => (
                <ReviewCard
                  key={r._id || r.id || i}
                  review={r}
                  delay={i * 0.05}
                  currentUser={user}
                  onEdit={() => onEditClick(r)}
                  onDelete={() => onDeleteClick(r._id || r.id)}
                />
              ))
            )}
          </div>
        ) : (
          <SavedKahanisPage user={user} />
        )}
      </main>
    </div>
</>
  );
}
